import { replace, useClasses, useClassesMapper } from '@xo-union/react-css-modules';
import React from 'react';
import { match, useHistory } from 'react-router-dom';

import { useWeddingWebsiteQuery } from '../../generated/graphql';
import styles from '../SharePage/sharePreview.scss';
import useShareTracking from '../SharePage/useShareTracking';
import PreviewOverlay from './SmsPreview/PreviewOverlay';

interface Props {
  match: match<{}> | null;
  editRoute?: string;
  seqId?: string;
  iframeRef: React.RefObject<HTMLIFrameElement>;
  setLoaded?: (b: boolean) => void;
  subject?: string;
  classes?: object;
  onClick?: () => void;
  showLinkButton?: boolean;
}

export const EmailPreview: React.FC<Props> = ({
  match,
  editRoute = '',
  seqId,
  iframeRef,
  setLoaded,
  subject,
  classes: classesProp,
  onClick,
  showLinkButton = true,
}) => {
  const { data } = useWeddingWebsiteQuery();
  const history = useHistory();
  const track = useShareTracking();

  // @ts-ignore
  const classes = useClasses(styles, classesProp);
  const classForNestedComponent = useClassesMapper(
    replace({
      previewFrame: styles.previewFrame,
      bodyContainer: styles.iframeContainer,
      emailPreview: styles.emailPreview,
    }),
    // @ts-ignore
    classesProp
  );

  const iFrameSrc = `${process.env.REACT_APP_GMS_URL}/v1/email-preview/${seqId}/${
    data?.weddingWebsite.themeId
  }?memberId=${data?.member?.id}&themeEmail=true&showLinkButton=${data?.weddingWebsite.state === 'published' &&
    showLinkButton}`;

  const editMessage = () => {
    if (onClick) {
      onClick();
    } else {
      track('WWS Share Interaction', { action: 'edit message initiated' });
      history.push(editRoute);
    }
  };

  return (
    <PreviewOverlay messageType="email" onClick={editMessage} match={match} classes={classForNestedComponent}>
      <div className={classes.emailPreview}>
        <div>
          <div className={classes.header}>New Email</div>
          <div className={styles.emailComposeDetails}>
            <div className={styles.emailComposeRow}>
              <div className={styles.emailComposeLabel}>From:</div>
              <div className={styles.emailComposeField}>
                {data?.member?.firstName} & {data?.member?.fianceFirstName}
              </div>
            </div>
            <div className={styles.emailComposeRow}>
              <div className={styles.emailComposeLabel}>Subject:</div>
              <div className={styles.emailComposeField}>{subject}</div>
            </div>
          </div>
        </div>

        {data?.weddingWebsite && data.member && seqId && (
          <div className={styles.iframeWrap}>
            <iframe
              ref={iframeRef}
              title="Preview"
              className={classes.iframe}
              onLoad={() => setLoaded && setLoaded(true)}
              src={iFrameSrc}
            />
          </div>
        )}
      </div>
    </PreviewOverlay>
  );
};
